// extracted by mini-css-extract-plugin
module.exports = {"iframePage":"PageWithIframe_iframePage__2ETci","iframeInner":"PageWithIframe_iframeInner__1m9go"};